import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextPos } from '../Pos';
import { Company } from '../../../../models/company.model';
import { PosCashier } from '../../../../models/pos.model';
import { StorageCenter } from '../../../../models/storage.center.model';
import { TreasuryAccount } from '../../../../models/treasury.account.model';
import { Settings } from '../../../../models/settings.model';
import { Variant } from '../../../../models/variant.model';
import { Service } from '../../../../models/service.model';
import { AccountingEntry } from '../../../../models/accounting.entry.model';
import { AppService } from '../../../../models/app.service.model';

export interface PosSalePageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  cashiersForCompany: PosCashier[] | null,
  accountingCreditEntriesForCompany: AccountingEntry[] | null,
  setCashiersForCompany: Dispatch<SetStateAction<PosCashier[] | null>>,
  loadCashiersForCompany: Function,
  storageCentersForCompany: StorageCenter[] | null,
  loadStorageCentersForCompany: Function,
  userLoggedIn: any,
  contactsForCompany: any,
  productsForCompany: any,
  productVariantsForCompany: Variant[] | null,
  servicesForCompany: Service[] | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  loadContactsForCompany: Function,
  settingsForCompany: Settings | null,
  loadSettingsForCompany: Function,
  loadProductproductVariantsForCompany: Function
};

const PosSalePage: React.FunctionComponent<PosSalePageProps> = props => {
  const {setRoute, appServiceForUser, companyForUser, userLoggedIn, accountingCreditEntriesForCompany, contactsForCompany, productsForCompany, productVariantsForCompany, servicesForCompany, storageCentersForCompany, treasuryAccountsForCompany, loadContactsForCompany, settingsForCompany, loadSettingsForCompany, loadStorageCentersForCompany, loadProductproductVariantsForCompany} = UseOutletContextPos()

  return (
    <Outlet context={{setRoute, appServiceForUser, companyForUser, accountingCreditEntriesForCompany, storageCentersForCompany, loadStorageCentersForCompany, userLoggedIn, contactsForCompany, productsForCompany, productVariantsForCompany, servicesForCompany, treasuryAccountsForCompany, loadContactsForCompany, settingsForCompany, loadSettingsForCompany, loadProductproductVariantsForCompany}}></Outlet>
  );
}

export function UseOutletContextPosSale() {
  return useOutletContext<ContexType>()
};

export default PosSalePage;
